var _style, _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 75",
    style: {
      enableBackground: "new 0 0 60 75"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "016-Array") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25,41.5H1c-0.6,0-1,0.4-1,1v24c0,0.6,0.4,1,1,1h24c0.6,0,1-0.4,1-1v-24C26,41.9,25.6,41.5,25,41.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3,31.5h20c0.6,0,1-0.4,1-1v-20c0-0.6-0.4-1-1-1H3c-0.6,0-1,0.4-1,1v20C2,31.1,2.4,31.5,3,31.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M59,7.5H35c-0.6,0-1,0.4-1,1v24c0,0.6,0.4,1,1,1h24c0.6,0,1-0.4,1-1v-24C60,7.9,59.6,7.5,59,7.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M59,41.5H35c-0.6,0-1,0.4-1,1v24c0,0.6,0.4,1,1,1h24c0.6,0,1-0.4,1-1v-24C60,41.9,59.6,41.5,59,41.5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArray);
export default __webpack_public_path__ + "static/media/array.a5c11cf260106e0713f3f7cf2f11348e.svg";
export { ForwardRef as ReactComponent };